exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".infohelper-panel-wrapper{position:relative;left:0}.infohelper-panel-wrapper .bg{background:#272626;opacity:.8}.infohelper-panel-wrapper .bg,.infohelper-panel-wrapper .infohelper-panel{position:absolute;top:0;right:0}.infohelper-panel-wrapper .x-btn{width:50px;height:50px;display:block;position:absolute;padding:10px;right:0;top:0;color:#ddd;text-align:center;text-decoration:none;z-index:10}.infohelper-button,.infohelper-button a{display:inline-block;width:14px;height:2em}.infohelper-button a{background-position:center center;background-repeat:no-repeat;line-height:14px;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/webpack/less/infohelper.less
// module id = 94
// module chunks = 3